import { mapValues } from '../../../lib/utilities';
import { Filters } from '../../_flux/constants/filter/filters';
import { updateFiltersAction } from '../../_flux/actions/catalog_filter_actions';
import {
    setValuesAction as setConfiguratorValuesAction,
    setBackupValuesAction as setConfiguratorBackupValuesAction
} from '../../_flux/actions/catalog_configurator_actions';
import { updateAvailableFilterOptionsAction } from '../../_flux/actions/filter_available_options_actions';
import { updateFilterOptionsAction } from '../../_flux/actions/filter_options_actions';
import { replaceWithOptionalFilterLabelTranslation } from '../../_modules/translation/replace_with_optional_filter_label_translation';
import { formatFilterDefaultLabel } from '../../_modules/filter/format_filter_default_label';
import { getPriceOptions } from '../../_flux/helper/get_price_options';
import { getDefaultLabelFormattingConfig } from '../catalog/set_initial_state';
import { getValue } from '../../utilities/local_storage';

export const setInitialStates = () => {
    const { region } = TYROOLA.initialFluxStates;
    const filters = {
        ...TYROOLA.initialFluxStates.filter.activeFilters,
        [Filters.POSTCODE]: getValue('shippingPostcode') || ''
    };

    updateFiltersAction({ ...filters, region });
    setConfiguratorValuesAction( filters );
    setConfiguratorBackupValuesAction(filters);
    updateAvailableFilterOptionsAction( TYROOLA.initialFluxStates.filter.availableOptions );
    updateFilterOptionsAction({
        ...mapValues( TYROOLA.initialFluxStates.filter.filterOptions, ((filterOption, filterName) => {
            if ( !Array.isArray( filterOption ) ) {
                return filterOption;
            }

            return filterOption.map( option => {
                const [ value, label ] = option;
                const defaultLabelFormattingConfig = getDefaultLabelFormattingConfig( filterName );
                const defaultLabel = formatFilterDefaultLabel( label, defaultLabelFormattingConfig );
                const formattedLabel = replaceWithOptionalFilterLabelTranslation( value, defaultLabel );

                return [ value, formattedLabel ];
            } );
        })),
        [Filters.PRICE_MIN]: getPriceOptions( 20000000, TYROOLA.globals.currencyIsoCode ),
        [Filters.PRICE_MAX]: getPriceOptions( 20000000, TYROOLA.globals.currencyIsoCode, true ),
    });
};
